import Typography from '@mui/material/Typography';
import DoneIcon from '@mui/icons-material/Done';
import _ from 'lodash';
import moment from 'moment';
import {getConfig} from '../../../../../util/configUtil';
import React from 'react';
import config from '../../../../../app/config';
import {
    MainButtonBackground,
    patientSafetyChecklistSectionValidation,
    SEPSIS_TOOL_TYPE,
} from '../../../forms/formsUtil';

export const renderReferralsText = (patient, header, background = false) => {
    let completedReferrals = false;
    const referralsLength = savedReferrals(patient);
    const defaultDateTimeFormat = getConfig('defaultDateTimeFormat');

    const checkFirstRef = () => {
        if (referralsLength > 0) {
            // Sort referrals by request date
            const sortRef = _.sortBy(patient?.studies?.referrals?.ReferralsToOtherServices, (ref) => {
                    return moment(`${ref.ActivityServiceRequestDate_EmergencyCare}T${ref.ActivityServiceRequestTime_EmergencyCare}`).toDate();
                },
            );

            // Filter uncompleted referrals only
            const filtered = _.filter(sortRef, (ref) => {
                return (_.isEmpty(ref.ReferredToServiceAssessmentDate) && _.isEmpty(ref.ReferredToServiceAssessmentTime));
            });

            if (!_.isEmpty(filtered)) {
                if (background) {
                    const nothingDone = filtered.length === sortRef.length;
                    return nothingDone ? MainButtonBackground.RED : MainButtonBackground.ORANGE;
                }

                // Render first unfinished referral on button
                return `- ${filtered[0]?.ReferredToService_SnomedCt?.__description}`;
            } else {
                // Display last completed referral on button
                completedReferrals = true;
                return background ? MainButtonBackground.GREEN : `- ${_.last(sortRef)?.ReferredToService_SnomedCt?.__description
                }`;
            }
        }
        return '';
    };

    if (background) {
        return checkFirstRef();
    }

    const getHeader = () => {
        return referralsLength > 0 ? `[${referralsLength}]` : '';
    };

    if (header) {
        return (
            <>
                <Typography variant="subtitle1" fontWeight="normal" sx={{pl: 0.2}}>
                    {`${getHeader()} ${checkFirstRef()}`}
                    {completedReferrals &&
                        <span style={{position: 'relative', marginLeft: 5}}>
                            <DoneIcon style={{position: 'absolute'}}/>
                        </span>
                    }
                </Typography>
            </>
        );
    }

    return (
        <>
            {referralsLength > 0 && (
                <div className="label-set" style={{paddingBottom: 0}}>
                    {patient?.studies?.referrals &&
                        <Typography variant="subtitle1">
                            <span className="label-part2">
                                {patient.studies.referrals.by}
                            </span>

                            <span className="label-part3">
                                {' '}
                                {moment(patient.studies.referrals.date).format(defaultDateTimeFormat)}
                            </span>
                        </Typography>
                    }
                </div>
            )}
        </>
    );
};

export const savedReferrals = (patient) => {
    if (!_.isEmpty(patient?.studies?.referrals?.ReferralsToOtherServices)) {
        return patient?.studies?.referrals?.ReferralsToOtherServices?.length;
    }
    return 0;
};


export const getClinicalConclusionBackground = (patient) => {
    const isClerkingDone = patient?.clerking?.who && patient?.clerking?.when;
    const isClinicalConclusionDone = patient?.clinicalConclusion?.who;

    if (!isClerkingDone) return '';
    return isClinicalConclusionDone ? '' : MainButtonBackground.RED;
};

export const getMessageToGpButtonBackground = (patient) => {
    if (patient?.clinicalConclusion && patient?.clinicalConclusion?.status === 'Discharge') {
        return !!patient?.studies?.clinicalCourse ? MainButtonBackground.GREEN : MainButtonBackground.RED;
    }
};

export const renderDependencyText = (patient) => {
    if (patient?.triage?.dependency) {
        const dependencyOption = patient?.triage?.dependency;

        return (
            <div className="label-set" style={{padding: '28px 10px 2px 10px'}}>
                <Typography variant="subtitle1" fontWeight="normal" style={{display: 'flex', alignItems: 'center'}}>
                    <div style={{
                        width: 20,
                        height: 20,
                        backgroundColor: dependencyOption?.color,
                        display: 'inline-block',
                    }}/>
                    <span style={{paddingLeft: 10}}>
                        {dependencyOption?.__description}
                    </span>
                </Typography>
            </div>
        );
    }
};

export const getSeeAndTreatButtonBackground = (patient) => {
    const isDraft = patient?.studies?.seeAndTreat?.status === 'draft';
    const isSeeAndTreatFilled = !!patient?.studies?.seeAndTreat;
    const triageVal = patient?.triage?.who || null;

    if (!!triageVal) return '';
    if (isDraft) return MainButtonBackground.ORANGE;
    if (!isSeeAndTreatFilled) return MainButtonBackground.RED;
    return MainButtonBackground.GREEN;
};

export const renderSeeAndTreatText = (patient) => {
    const defaultDateTimeFormat = getConfig('defaultDateTimeFormat');

    if (patient.studies?.seeAndTreat) {
        if (patient.studies?.seeAndTreat?.status === 'draft') {
            return (
                <div className="label-set" style={{display: 'flex', flexDirection: 'column', paddingBottom: 0}}>
                    <Typography variant="subtitle1" fontWeight="normal">
                        <span style={{paddingLeft: 10}}>Draft: <br/> </span>
                    </Typography>

                    <div>
                        <Typography variant="subtitle1">
                                <span className="label-part2">
                                    {patient.studies?.seeAndTreat?.by}
                                </span>

                            <span className="label-part3">
                                    {moment(patient.studies?.seeAndTreat?.when).format(defaultDateTimeFormat)}
                                </span>
                        </Typography>
                    </div>
                </div>
            );
        }

        if (patient.studies?.seeAndTreat?.status === 'timestamp') {
            return (
                <div className="label-set">
                    <Typography variant="subtitle1">
                        <span style={{paddingLeft: 10}}>Time Stamp: <br/> </span>

                        <div>
                                <span className="label-part2">
                                    {patient.studies?.seeAndTreat?.by}
                                </span>

                            <span className="label-part3">
                                    {moment(patient.studies?.seeAndTreat?.when).format(defaultDateTimeFormat)}
                                </span>
                        </div>
                    </Typography>
                </div>
            );
        } else {
            return (
                <div className="label-set">
                    <Typography variant="subtitle1">
                        <br/>
                        <span className="label-part2">
                            {patient.studies?.seeAndTreat?.clinician?.__description}
                        </span>

                        <span className="label-part3">
                            {moment(patient.studies?.seeAndTreat?.when).format(defaultDateTimeFormat)}
                        </span>
                    </Typography>
                </div>
            );
        }
    }
};

export const boardRoundButtonColor = (patient) => {
    if (!_.isEmpty(patient?.boardRound?.list?.[0])) {
        let nextBoardTimeConfig = getConfig('boardRoundMorning', '08:00');
        let nextBoardType = 'Morning';

        const today = moment();
        const hour = moment().hour();
        const hourMorning = moment(nextBoardTimeConfig, 'HH:mm').hour();

        if (hour > hourMorning) {
            nextBoardTimeConfig = getConfig('boardRoundEvening', '17:00');
            nextBoardType = 'Evening';
        }

        let nextBoardTime = moment(nextBoardTimeConfig, 'HH:mm');
        let leftMinutesToNextBoard = nextBoardTime.diff(moment(), 'minutes');

        // next board is done
        for (const boardRound of patient?.boardRound.list) {
            const momentBoardRound = moment(boardRound.date);

            if (today.isSame(momentBoardRound, 'day') &&
                nextBoardType === boardRound.timeBoardRound) {
                return MainButtonBackground.GREEN;
            }
        }

        // next board not
        if (leftMinutesToNextBoard < 0) return MainButtonBackground.RED;
        if (leftMinutesToNextBoard < 60) return MainButtonBackground.ORANGE;
        if (leftMinutesToNextBoard > 60) return MainButtonBackground.GREEN;

    }
    return MainButtonBackground.RED;
};

export const currentClinicianRender = (patient) => {
    if (!_.isEmpty(patient?.currentClinicianIP)) {
        return (
            <div>
                <Typography variant="subtitle2" fontWeight="normal" sx={{pl: .2}}>
                    <div style={{paddingLeft: 8}}>
                        {patient?.currentClinicianIP?.specialty?.__description}
                    </div>

                    {patient?.currentClinicianIP?.consultant &&
                        <span className="label-part2">
                             {patient?.currentClinicianIP.consultant.familyName}, {patient?.currentClinicianIP.consultant.firstName}
                        </span>
                    }

                    {patient?.currentClinicianIP?.date &&
                        <span className="label-part3">
                            {moment(patient?.currentClinicianIP.date).format(config.defaultDateTimeFormat)}
                        </span>
                    }
                </Typography>
            </div>
        );
    }
};

export const oxygenRender = (patient) => {
    if (!_.isEmpty(patient?.oxygen)) {
        return (
            <div>
                <Typography variant="subtitle2" fontWeight="normal" sx={{pl: .2}}>
                    <div style={{paddingLeft: 8}}>
                        {patient?.oxygen?.lower}%
                        - {patient?.oxygen?.upper}%
                    </div>

                    {patient?.oxygen?.who &&
                        <span className="label-part2">
                            {patient?.oxygen?.who}
                        </span>
                    }

                    {patient?.oxygen?.date &&
                        <span className="label-part3">
                            {moment(patient?.oxygen.date).format(config.defaultDateTimeFormat)}
                        </span>
                    }
                </Typography>
            </div>
        );
    }
};

export const clerkingButtonColor = (patient) => {
    if (!_.isEmpty(patient?.clerkingIP)) {
        if (!patient?.clerkingIP.statusClosed) return MainButtonBackground.ORANGE;
        else return MainButtonBackground.GREEN;
    }
    return MainButtonBackground.RED;
};

export const formButtonColor = (form) => {
    if (!_.isEmpty(form)) {
        return MainButtonBackground.GREEN;
    }
    return MainButtonBackground.RED;
};

export const intendentManagementButtonColor = (patient) => {
    if (!_.isEmpty(patient?.intendentManagement)) {
        if (patient?.intendentManagement.cdd) return MainButtonBackground.GREEN;
        if (patient?.intendentManagement.edd) return MainButtonBackground.ORANGE;
    }
    return MainButtonBackground.RED;
};

export const intendentManagementRender = (patient) => {
    if (!_.isEmpty(patient?.intendentManagement)) {
        return (
            <div>
                <Typography variant="subtitle2" fontWeight="normal" sx={{pl: .2}}>
                    <div
                        style={{
                            paddingLeft: '8px',
                            color: 'rgb(78, 172, 111)',
                            display: 'flex',
                            justifyContent: 'space-between',
                            paddingRight: '15px',
                            fontWeight: 600,
                            paddingTop: '10px',
                        }}
                    >
                        <div> EDD: {moment(patient?.intendentManagement.edd).format(config.defaultDateFormat)} </div>
                        {patient?.intendentManagement.cdd &&
                            <div> CDD: {moment(patient?.intendentManagement.cdd).format(config.defaultDateFormat)} </div>
                        }
                    </div>

                    {patient?.intendentManagement?.who &&
                        <span className="label-part2">
                            {patient?.intendentManagement?.who}
                        </span>
                    }

                    {patient?.intendentManagement?.date &&
                        <span className="label-part3">
                            {moment(patient?.intendentManagement.date).format(config.defaultDateTimeFormat)}
                        </span>
                    }
                </Typography>
            </div>
        );
    }
};

export const renderDeliriumText = (patient, header = false) => {
    const defaultDateTimeFormat = getConfig('defaultDateTimeFormat');

    if (!_.isEmpty(patient?.studies?.delirium?.list)) {
        const filterArr = _.filter(patient.studies.delirium.list, (entry) => !entry?.canceled);
        const lastDeli = !_.isEmpty(filterArr) ? filterArr[0] : null;
        const trend = !lastDeli?.lastScore ? '' : lastDeli?.lastScore > lastDeli?.totalScore
            ? '↓' : lastDeli?.lastScore === lastDeli?.totalScore ? '' : '↑';

        if (header) {
            return _.isEmpty(filterArr) ? 'Delirium Screening' : `[${filterArr ? filterArr.length : 0}] Delirium Screening - Score: ${lastDeli.totalScore} ${trend}`;
        }

        return (
            lastDeli &&
            <div className="label-set" style={{paddingBottom: 0}}>
                <Typography variant="subtitle1">
                    <br/>

                    <span className="label-part2">
                        {patient?.studies?.delirium?.by}
                    </span>

                    <span className="label-part3">
                        {moment(patient?.studies?.delirium?.date).format(defaultDateTimeFormat)}
                    </span>
                </Typography>
            </div>
        );
    }
    return header ? (<div className="label-part1">Delirium Screening</div>) : null;
};

export const renderRockwoodText = (patient, header) => {
    const defaultDateTimeFormat = getConfig('defaultDateTimeFormat');

    if (!_.isEmpty(patient?.studies?.rockwood?.list)) {
        const filterArr = _.filter(patient.studies.rockwood.list, (entry) => !entry?.canceled);
        const lastRockwood = !_.isEmpty(filterArr) ? filterArr[0] : null;
        const score = lastRockwood?.scale?.score ? lastRockwood?.scale?.score : lastRockwood?.scale?.__code;
        const trend = !lastRockwood?.lastScore ? '' : Number(lastRockwood?.lastScore) > Number(score) ? '↓'
            : Number(lastRockwood?.lastScore) === Number(score) ? '' : '↑';

        if (header) {
            return _.isEmpty(filterArr) ? 'Clinical Frailty Score' : `[${filterArr ? filterArr.length : 0}] Clinical Frailty Score - Score: ${score} ${trend}`;
        }

        return (
            lastRockwood &&
            <div className="label-set" style={{paddingBottom: 0}}>
                <Typography variant="subtitle1">
                    <br/>

                    <span className="label-part2">
                        {lastRockwood?.by}
                    </span>

                    <span className="label-part3">
                        {moment(lastRockwood?.date, defaultDateTimeFormat).isValid() ? lastRockwood?.date : moment(lastRockwood?.date).format(defaultDateTimeFormat)}
                    </span>
                </Typography>
            </div>
        );
    }
    return header ? (<div className="label-part1">Clinical Frailty Score</div>) : null;
};

export const lastUpdateNutrition = (ptData, isPaeds) => {
    const defaultDateTimeFormat = getConfig('defaultDateTimeFormat');

    if (!_.isEmpty(ptData?.other?.nutritionScreen)) {
        const lastItem = _.last(_.filter(ptData?.other?.nutritionScreen, (el) => !el.canceled));

        if (lastItem) {
            const nutritionDetails = ` Weight: ${lastItem?.weight ? `${lastItem?.weight} kg` : 'NR'},` +
                ` Height: ${lastItem?.height ? `${lastItem?.height} cm` : 'NR'}` +
                `${isPaeds ? '' : `, BMI: ${lastItem?.bmi ? lastItem?.bmi : 'NR'}`}`;

            return (
                <div>
                    <Typography variant="subtitle2" fontWeight="normal" sx={{pl: .2}}>
                        <div style={{paddingLeft: 8}}>
                            {nutritionDetails}
                        </div>

                        {lastItem?.by &&
                            <span className="label-part2">
                                {lastItem.by}
                            </span>}

                        {lastItem?.date &&
                            <span className="label-part3">
                                {moment(lastItem.date).format(defaultDateTimeFormat)}
                            </span>}
                    </Typography>
                </div>
            );
        }
    }
};

export const getPSCBtnColor = (patient, countdown) => {
    const patientSafetyChecklistConfig = getConfig('patientSafetyChecklist', {});

    if (!patientSafetyChecklistConfig?.enabled) {
        return;
    }
    const psc = patient?.studies?.safetyChecklist;

    const timeX = patientSafetyChecklistConfig?.timeoutMinutesX || 30;
    const timeY = patientSafetyChecklistConfig?.timeoutMinutesY || 15;

    const colorGreen = patientSafetyChecklistConfig?.green;
    const colorOrange = patientSafetyChecklistConfig?.orange;
    const colorRed = patientSafetyChecklistConfig?.red;

    let dateToCheck;
    let countdownMinutes;
    let countdownTimestamp;

    let lastObs;
    let lastObsTimestamp;
    let validFourSections = false;

    if (!psc) {
        return '';
    }

    const {obsFirst, obsSecond, obsThird, obsFourth, nextHours} = psc;

    const validSection1 = patientSafetyChecklistSectionValidation(psc, 1, patient?.patient);

    if (validSection1 === undefined) {
        return '';
    }

    const validSection2 = validSection1 && patientSafetyChecklistSectionValidation(psc, 2);
    const validSection3 = validSection2 && patientSafetyChecklistSectionValidation(psc, 3);
    const validSection4 = validSection3 && patientSafetyChecklistSectionValidation(psc, 4);

    const checkValidAndReturn = () => {
        if (validSection4) {
            validFourSections = true;
            return obsFourth;
        } else if (validSection3) {
            return obsThird;
        } else if (validSection2) {
            return obsSecond;
        } else {
            return obsFirst;
        }
    };

    lastObs = checkValidAndReturn();
    lastObsTimestamp = moment(lastObs?.createDate ?? lastObs?.timestamp ?? lastObs?.date).format('x');

    // Get time of Triage/S&T form completed
    if (patient?.triage && patient?.studies?.seeAndTreat) {
        dateToCheck = moment(patient?.studies?.seeAndTreat?.when).isAfter(moment(patient?.triage?.when))
            ? patient?.triage?.when
            : patient?.studies?.seeAndTreat?.when;
    } else {
        if (patient?.studies?.seeAndTreat) dateToCheck = patient?.studies?.seeAndTreat?.when;
        if (patient?.triage) dateToCheck = patient?.triage?.when;
    }
    if (dateToCheck) {
        countdownMinutes = moment(+lastObsTimestamp).add(1, 'hours').diff(moment(), 'minutes');
        countdownTimestamp = moment(+lastObsTimestamp).add(1, 'hours');
        dateToCheck = moment(dateToCheck).format('x');
    }

    const isBiggerThanX = countdownMinutes > timeX;
    const betweenXandY = countdownMinutes >= timeY && countdownMinutes < timeX;

    if (countdown) {
        return countdownTimestamp;
    }

    if (validFourSections) {
        return colorGreen;
    }

    if (dateToCheck) {
        if (isBiggerThanX) {
            return colorGreen;
        } else if (betweenXandY) {
            return colorOrange;
        } else if (countdownMinutes < timeY) {
            return colorRed;
        } else return '';
    }
};

export const renderPrescriptionText = (patient, header) => {
    const defaultDateTimeFormat = getConfig('defaultDateTimeFormat');

    if (!_.isEmpty(patient?.studies?.prescription?.list)) {
        const filterArr = _.filter(patient.studies.prescription.list, (entry) => !entry?.canceled);
        const lastPres = !_.isEmpty(filterArr) ? filterArr[0] : null;

        return (
            lastPres && (
                <div className="label-set">
                    <Typography variant="subtitle1" sx={{mt: 2.85, pb: .5}}>
                            <span className="label-part2">
                                {patient?.studies?.prescription?.by}
                            </span>

                        <span className="label-part3">
                                {moment(patient?.studies?.prescription?.date).format(defaultDateTimeFormat)}
                            </span>
                    </Typography>
                </div>
            )
        );
    }
    return header ? (<div className="label-part1">DELIRIUM SCREENING</div>) : null;
};

export const getLastScreeningTool = (patientAddData, patient) => {
    let sepsisTool = _.filter(patientAddData?.other?.sepsisTool, (form) => form?.status !== 'CANCELED');

    if (sepsisTool) {
        const startDate = moment(patient.admission?.startDate);
        const endDate = patient.admission?.endDate ? moment(patient.admission?.endDate) : moment();

        sepsisTool = _.filter(sepsisTool, record => {
            return moment(record.date).isBetween(startDate, endDate) && !record.deleted;
        });

        return _.last(sepsisTool);
    }
    return null;
};

export const getSepsisButtonBackground = (patientAddData, patient) => {
    const lastSepsis = getLastScreeningTool(patientAddData, patient);
    const isDraft = lastSepsis?.status === SEPSIS_TOOL_TYPE.IN_COMPLETED;
    if (isDraft) return MainButtonBackground.ORANGE;
};

export const smokerRender = (patient) => {
    const defaultDateTimeFormat = getConfig('defaultDateTimeFormat');

    if (!_.isEmpty(patient?.smoking)) {
        return (
            <div>
                <Typography variant="subtitle2" fontWeight="normal" sx={{pl: .2}}>
                    <div style={{paddingLeft: 8}}>
                        Status: {patient?.smoking?.smoker}
                    </div>

                    {patient?.smoking?.who &&
                        <span className="label-part2">
                            {patient?.smoking.who}
                        </span>
                    }

                    {patient?.smoking?.date &&
                        <span className="label-part3">
                            {moment(patient?.smoking.date).format(defaultDateTimeFormat)}
                        </span>
                    }
                </Typography>
            </div>
        );
    }
};

export const getLastUrinalysis = (patientAddData, patient) => {
    if (patientAddData?.other?.urinalysis) {
        let records = patientAddData?.other?.urinalysis;
        const startDate = moment(patient.admission?.startDate);
        const endDate = patient.admission?.endDate ? moment(patient.admission?.endDate) : moment();

        records = _.filter(records, record => {
            return moment(record.when).isBetween(startDate, endDate) && !record.deleted;
        });
        return _.last(records);
    }
    return null;
};

export const renderEmed3Text = (patient, header) => {
    const defaultDateTimeFormat = getConfig('defaultDateTimeFormat');

    if (!_.isEmpty(patient?.studies?.fitnessForWork?.list)) {
        const filterArr = _.filter(patient.studies.fitnessForWork.list, (entry) => !entry?.canceled);
        const lastEmed = !_.isEmpty(filterArr) ? filterArr[0] : null;
        const advise = lastEmed?.advise === 'maybeFit' ? 'may be fit for work' : 'not fit for work';
        const dateFrom = moment(lastEmed?.caseFrom).format(defaultDateTimeFormat);
        const dateTo = moment(lastEmed?.caseFrom).format(defaultDateTimeFormat);


        if (header) {
            return _.isEmpty(filterArr) ? <div>eMed3</div> : <div>eMed3 - {advise}</div>;
        }

        return (
            lastEmed &&
            <div className="label-set" style={{paddingBottom: 0}}>
                <Typography variant="subtitle1">
                    <span className="label-part2">
                        {`from ${dateFrom} to ${dateTo}`}
                    </span>

                    <br/>

                    <span className="label-part2">
                        {lastEmed?.by}
                    </span>

                    <span className="label-part3">
                        {moment(lastEmed?.date, defaultDateTimeFormat).isValid() ? lastEmed?.date : moment(lastEmed?.date).format(defaultDateTimeFormat)}
                    </span>
                </Typography>
            </div>
        );
    }
    return header ? (<div className="label-part1">eMed3</div>) : null;
};

export const renderCSMLabel = (patient, background = false) => {
    const enableBedRequestForm = getConfig('modules.forms.bedBooking.enableBedRequestForm', false);

    if (enableBedRequestForm) {
        const br = patient?.studies?.bedRequest;

        if (br?.canceled) return 'Canceled';
        if (br?.ready) return background ? MainButtonBackground.GREEN : 'Ready';
        if (br?.allocated) return background ? MainButtonBackground.ORANGE : 'Allocated';
        if (br?.requested) return background ? MainButtonBackground.RED : 'Requested';
        return '';
    } else {
        switch (patient?.csmContactedTime?.bed) {
            case 'req':
                return 'Requested';
            case 'ready':
            case 'canceled':
            case 'allocated':
                return _.startCase(patient?.csmContactedTime?.bed);
            default:
                return '';
        }
    }
};